import Slider from "react-slick";
import logo from './../../../../assets/img/logo.png';
import vid2 from './../../../../assets/vid/2.mp4';

const WelcomeArea = () => {
    const slideCateg = {
        infinite: true,
        speed: 500,
        autoplaySpeed: 10000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: false,        
    };

  return (
    <>
    <section className="welcome_area overflow-hidden" id="home">
        <div className="hero-slides">
            <Slider {...slideCateg}>
                <div className="single-hero-slide d-flex align-items-end justify-content-center">
                    <div className="hero-slide-content text-center">
                        <div className="d-flex align-items-center justify-content-center">
                            <img src={logo} title="MIPAT" alt="MIPAT" className="logo" /> &nbsp; 
                            <h2 style={{ lineHeight: '90%' }}>
                                <b>Modern Integrated Farms <br />and Food Processing Ltd.</b>
                            </h2>
                        </div>

                        <h6>A registered company specializing in the processing of natural and organic resources.</h6>
                    </div>
                </div>

                <div className="single-hero-slide d-flex align-items-end justify-content-center">
                    <div className="hero-slide-content text-center">
                        <div className="d-flex align-items-center justify-content-center">
                            <h5 className="text-left" style={{ lineHeight: '90%', fontWeight: '400', 
                                color: '#8EC62F', paddingRight: '1rem', borderRight: '1px solid #aaa'
                             }}>
                                Our <br />
                                Product
                            </h5>
                            
                            <h2 style={{ lineHeight: '90%', paddingLeft: '1rem',  }}>
                                <b>SpillClean Powder&trade;</b>
                            </h2>
                        </div>

                        <h6>Spillage cleaning solution for hydrocarbons, chemicals, automative fluids, crude oil, etc.</h6>
                    </div>
                </div>

                <div className="single-hero-slide d-flex align-items-end justify-content-center">
                    <div className="hero-slide-content text-center">
                        <div className="d-flex align-items-center justify-content-center">
                            <h5 className="text-left" style={{ lineHeight: '90%', fontWeight: '400', 
                                color: '#8EC62F', paddingRight: '1rem', borderRight: '1px solid #aaa'
                             }}>
                                Our <br />
                                Product
                            </h5>
                            
                            <h2 style={{ lineHeight: '90%', paddingLeft: '1rem',  }}>
                                <b>Fertilizer & Water Mixing Machine</b>
                            </h2>
                        </div>

                        <h6><i>Brief info about product</i></h6>
                    </div>
                </div>

                <div className="single-hero-slide d-flex align-items-end justify-content-center">
                    <div className="hero-slide-content text-center">
                        <div className="d-flex align-items-center justify-content-center">
                            <h5 className="text-left" style={{ lineHeight: '90%', fontWeight: '400', 
                                color: '#8EC62F', paddingRight: '1rem', borderRight: '1px solid #aaa'
                             }}>
                                Our <br />
                                Product
                            </h5>
                            
                            <h2 style={{ lineHeight: '90%', paddingLeft: '1rem',  }}>
                                <b>Cocopeat & Coconut Husk Chips</b>
                            </h2>
                        </div>

                        <h6><i>Brief info about product</i></h6>
                    </div>
                </div>
            </Slider>

            <div className="text-center vid">
                <video autoPlay loop muted playsInline controls width="63%" height="60%" 
                    // style={{ border: '2rem solid #E3DFEF', borderRadius: '1.5rem' }}
                    >
                    <source src={vid2} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>
        </div>
    </section> 
    </>
  )
}

export default WelcomeArea
